export const loginState = state => state
